<template>
  <div class="join_now" :class="{ join_now_flow: fixed }">
    <div class="join_now_link" @click="joinNow" :style="{ background: 'url(' + shouImgUrl() + ') no-repeat center center' }">
      <img class="join_now_close" v-if="fixed" src="../../../assets/imgs/join_now_close.png" @click.stop="close">
      <div class="join_now_background">
        <div class="money">
          <span>¥</span>
          <span>{{ newPeerCouponAmount }}{{maxCouponAmount ? maxCouponAmount / 100 : undefined}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import sensorsdata from 'sa-sdk-javascript';

import User from '../../../libs/user';

import placeOrderImg from '../../../assets/imgs/place_order.png';
import joinNowImg from '../../../assets/imgs/join_now.png';

export default {
  name: 'join-now',
  props: {
    fixed: {
      type: Boolean,
      default: false,
    },
    maxCouponAmount: {
      type: Number,
    },
  },
  computed: {
    ...mapState('config', {
      maxRate(state) {
        return state.balance_config.max_rate ? state.balance_config.max_rate : 0;
      },
      newPeerAmount(state) {
        return (state.balance_config.first_order_reduce ? this.$showPrice(state.balance_config.first_order_reduce) : 0);
      },
      totalCouponAmount(state) {
        return (state.balance_config.total_coupon_amount ? this.$showPrice(state.balance_config.total_coupon_amount) : 0);
      },
      newPeerCouponAmount(state) {
        if (!User.isLogin()) {
          return (state.new_peer_coupon_amount ? this.$showPrice(state.new_peer_coupon_amount) : 0);
        }
      },
    }),
  },
  methods: {
    ...mapMutations(['SHOW_LOGIN_BOX']),
    close(e) {
      this.$emit('close', e);
    },
    joinNow(e) {
      if (User.isLogin()) {
        window.location.href = 'https://www.666visa.cn/activity?id=10010';
      } else {
        sensorsdata.quick('trackHeatMap', e.target);
        this.SHOW_LOGIN_BOX({ page: 5 });
      }
    },
    shouImgUrl() {
      return User.isLogin() ? placeOrderImg : joinNowImg;
    },
  },
};
</script>

<style lang="less">
.join_now {
  display: inline-block;
  vertical-align: top;
  width: 100%;
  height: 100px;
  background: #f44b4c;

  .join_now_link {
    cursor: pointer;
    width: 1350px;
    height: 150px;
    margin: 0 auto;
    // background: url(../../../assets/imgs/join_now.png) no-repeat center center;
    position: relative;
    bottom: 50px;
  }
  .join_now_background {
    margin: 0 auto;
    font-size: 0;
    .money {
      position: absolute;
      top: 74px;
      left: 650px;
      span {
        color: #fff8c5;
        font-size: 25px;
        text-shadow: 0px 2px 0px #cd282b;
      }
      span:last-of-type {
        font-size: 44px;
      }
    }
  }
  .join_now_close {
    position: fixed;
    bottom: 70px;
    right: 20px;
  }
}

.join_now.join_now_flow {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1003;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/join-now.vue